import FontAwesome from '@expo/vector-icons/FontAwesome';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useCallback, useMemo, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { useTextsetContext } from '@/contexts/TextSetContext/useTextsetContext';
import { ContentText } from './ContentText';
import { styles } from './styles';
import { Modal } from '@/components/ui/therapist/Modal';
import { Button } from '@/components/ui/therapist/Button';
import RadioButton from '@/components/ui/therapist/RadioButton';
import { StateType } from '@/contexts/TextSetContext/types';

type RadioOption = { value: string; label: string };
type FilterConfig = {
  key: keyof StateType;
  label: string;
  radios: RadioOption[];
};

const CONFIG: FilterConfig[] = [
  {
    key: 'complexity',
    label: 'Thema und Wortschatz: ',
    radios: [
      { value: 'einfach', label: 'einfach' },
      { value: 'schwierig', label: 'schwierig' },
    ],
  },
  {
    key: 'textLength',
    label: 'Länge und Syntax: ',
    radios: [
      { value: 'kurz', label: 'kurz und einfach' },
      { value: 'lang', label: 'lang und komplex' },
    ],
  },
];

export function Filter() {
  const { complexity, changeOuterState, textLength } = useTextsetContext();

  const handleRadioChange = useCallback(
    (name: keyof StateType, value: string) => {
      return () => {
        changeOuterState(name, value);
      };
    },
    [],
  );

  const RADIO_BTNS = useMemo(() => {
    return CONFIG.map((each) => {
      const { key, label, radios } = each;
      const currentValue = key === 'complexity' ? complexity : textLength;
      return (
        <View style={innerStyles.viewStyle} key={label}>
          <Text style={innerStyles.textStyle}>{label}</Text>
          {radios.map((radio) => (
            <View key={radio.value} style={{ marginHorizontal: 8 }}>
              <RadioButton
                isSelected={currentValue == radio.value}
                label={radio.label}
                onPress={handleRadioChange(key, radio.value)}
                labelStyle={{ fontWeight: 'bold' }}
              />
            </View>
          ))}
        </View>
      );
    });
  }, [complexity, textLength]);

  const [showModal, setShowModal] = useState(false);

  const toggleModal = useCallback(() => {
    setShowModal((prevState) => !prevState);
  }, []);

  return (
    <>
      <View style={[styles.filter]}>
        <View style={styles.filterStatic}>
          <View style={styles.filterRadioContainer}>
            <Text
              style={[styles.filterRadioContainerTitle, styles.filterRadioItem]}
            >
              Texteigenschaften
            </Text>
          </View>
          <View style={styles.filterButtons}>
            <PressableNeolexon
              onPress={toggleModal}
              style={[styles.filterButton, styles.buttonShadowDrop]}
            >
              <FontAwesome name="question" size={24} color="black" />
            </PressableNeolexon>
          </View>
        </View>
        {RADIO_BTNS}
      </View>
      <Modal
        onClose={toggleModal}
        isVisible={showModal}
        confirmActionButton={<Button label="Schließen" onPress={toggleModal} />}
        title="Hier legen Sie fest, welche Eigenschaften die Texte haben, die Ihnen angezeigt werden."
      >
        <ScrollView>
          <ContentText />
        </ScrollView>
      </Modal>
    </>
  );
}

const innerStyles = StyleSheet.create({
  container: {
    flex: 1,
  },
  textStyle: {
    fontSize: 16,
  },
  viewStyle: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
});
